import { render, staticRenderFns } from "./family.vue?vue&type=template&id=4a3dd6ee&scoped=true&"
import script from "./family.vue?vue&type=script&lang=js&"
export * from "./family.vue?vue&type=script&lang=js&"
import style0 from "./family.vue?vue&type=style&index=0&id=4a3dd6ee&scoped=true&lang=css&"
import style1 from "./family.vue?vue&type=style&index=1&id=4a3dd6ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3dd6ee",
  null
  
)

export default component.exports